import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import PendingDomainsPanel from '../../components/templates/admin/PendingDomainsPanel';

const PendingDomainsPage = () => {
  return (
    <AdminLayout>
      <PendingDomainsPanel />
    </AdminLayout>
  );
};

export default PendingDomainsPage;
